<template>
    <div class="background" />
</template>

<script>
    export default {
        name: 'main-background',
    };
</script>

<style lang="scss" scoped>
    .background {
        background: url('../../assets/images/background.jpg');
        background-color: #f9f9f9;
        position: fixed;
        right: 0;
        left: 0;
        bottom: 0;
        top: 0;
        z-index: -1;
        background-size: cover;
    }
</style>
